<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-progress-circular
            :rotate="-90"
            :indeterminate="loading"
            size="16"
            :width="width"
            :value="value"
            color="blue-grey lighten-1"
            @click="onClick()"
            v-bind="attrs"
            v-on="on"
        >
          <template><small>r</small></template>
        </v-progress-circular>
      </template>
      <span>refresh {{1800 - value}}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "CommonRefresh",

  props: {
    loading: {default: null},
  },

  computed: {
    width() {
      if (this.loading)
        return 1
      else
        return 4
    },
  },

  methods: {
    onClick() {
      this.$emit('click')
    },
  },

  mounted() {
    this.interval = setInterval(() => {
      if (this.value >= 9000) {
        this.value = 0
        this.onClick()
      }
      this.value += 1
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  data() {
    return {
      value: 0,
      interval: {},
    }
  },
}
</script>

<style scoped>

</style>

<i18n src="@/components/Common/locales.json">
</i18n>